import type { IssueModel } from 'shared/domain/issue/issueModel';
import { IssueReferenceName, type IssueReferences } from 'shared/domain/issue/issueReferences';
import type { ProcessType } from 'shared/domain/process/types/model';
import { findById } from 'shared/utils/id/findById';
import type { EntityByIdRead } from 'store/entityCollection';
import type { IssueReferenceIds, IssueReferenceReads, IssueReferencesState } from './types';

export function resolveIssueReferences({ site, level, process }: IssueReferenceReads): IssueReferencesState {
  // A read the worker did not answer is not a missing entity: the issue waits instead of showing "not found".
  if (site.loading || level.loading || process.loading || site.readFailed || level.readFailed) {
    return {};
  }
  if (!site.item) {
    return { missing: IssueReferenceName.SITE };
  }
  if (!level.item) {
    return { missing: IssueReferenceName.LEVEL };
  }
  if (!process.item) {
    return { missing: IssueReferenceName.PROCESS };
  }
  return { references: { site: site.item, level: level.item, process: process.item } };
}

export function getIssueReferenceIds(issueModel: IssueModel | undefined): IssueReferenceIds {
  return {
    [IssueReferenceName.SITE]: issueModel?.primaryData.site,
    [IssueReferenceName.LEVEL]: issueModel?.primaryData.level,
    [IssueReferenceName.PROCESS]: issueModel?.process,
  };
}

/**
 * The process of the issue from the project's processes. Process ids are codes
 * (`PROCESS_QA`), not ObjectIds: `findById` compares them as they are, while
 * `areObjectIdsEqual` takes any two codes for equal (PT-7334).
 */
export function readIssueProcess(
  processes: ProcessType[],
  areProcessesReady: boolean,
  processId: string | undefined
): EntityByIdRead<IssueReferences['process']> {
  return { item: findById(processes, processId), loading: !areProcessesReady };
}
